import { render, staticRenderFns } from "./ClientInput.vue?vue&type=template&id=5fe8cdd4&"
import script from "./ClientInput.vue?vue&type=script&lang=js&"
export * from "./ClientInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClientInput.vue"
export default component.exports